var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_3098)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33946 5.81601C2.58999 2.90957 5.02862 0.628662 7.99999 0.628662C10.9714 0.628662 13.41 2.90957 13.6605 5.81601H12.6576C12.4104 3.46166 10.4195 1.62701 7.99999 1.62701C5.58052 1.62701 3.58956 3.46166 3.34237 5.81601H2.33946Z",
    fill: "#9D907A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0524 11.0762C2.21937 11.089 2.42137 11.0963 2.6243 11.0844C2.7324 11.6326 2.87615 12.6715 3.46421 13.2595C3.99637 13.7917 4.71815 14.0906 5.47074 14.0906H6.78815C6.7713 14.1827 6.76268 14.2766 6.76268 14.3714C6.76268 14.4673 6.77134 14.5612 6.78787 14.6522H5.47074C4.56921 14.6522 3.70462 14.2941 3.06712 13.6566C2.34015 12.9296 2.16537 11.7773 2.0524 11.0762Z",
    fill: "#9D907A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59872 6.27218C3.59872 5.9134 3.34137 5.62256 3.02387 5.62256H1.82822C1.34334 5.62256 0.878312 5.84025 0.535469 6.22768C0.192625 6.61515 0 7.14065 0 7.68862V9.28228C0 9.83025 0.192625 10.3557 0.535469 10.7432C0.878312 11.1307 1.34334 11.3483 1.82822 11.3483H3.02387C3.34137 11.3483 3.59872 11.0575 3.59872 10.6987V6.27218Z",
    fill: "#DA9B31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.06206 5.62256V11.3483H1.82822C1.34334 11.3483 0.878312 11.1307 0.535469 10.7432C0.192625 10.3557 0 9.83025 0 9.28228V7.68862C0 7.14065 0.192625 6.61515 0.535469 6.22768C0.878312 5.84025 1.34334 5.62256 1.82822 5.62256H2.06206Z",
    fill: "#F5B547"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.68862C16 7.14065 15.8074 6.61515 15.4645 6.22768C15.1217 5.84025 14.6567 5.62256 14.1718 5.62256H12.9761C12.6586 5.62256 12.4013 5.9134 12.4013 6.27218V10.6987C12.4013 11.0575 12.6586 11.3483 12.9761 11.3483H14.1718C14.6567 11.3483 15.1217 11.1307 15.4645 10.7432C15.8074 10.3557 16 9.83025 16 9.28228V7.68862Z",
    fill: "#DA9B31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9379 5.62256H14.1718C14.6567 5.62256 15.1217 5.84025 15.4645 6.22768C15.8074 6.61515 16 7.14065 16 7.68862V9.28228C16 9.83025 15.8074 10.3557 15.4645 10.7432C15.1217 11.1307 14.6567 11.3483 14.1718 11.3483H13.9379V5.62256Z",
    fill: "#F5B547"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61168 14.3715C9.61168 13.8194 9.16412 13.3718 8.61202 13.3718H7.38796C7.12284 13.3718 6.86856 13.4772 6.68109 13.6646C6.49362 13.8521 6.38831 14.1064 6.38831 14.3715C6.38831 14.9236 6.83587 15.3711 7.38796 15.3711H8.61202C9.16412 15.3711 9.61168 14.9236 9.61168 14.3715Z",
    fill: "#CFB079"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_3098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDesk);
export default __webpack_public_path__ + "static/media/HelpDesk.8e0ee229e1ddd9d8c8d436c32f446ab7.svg";
export { ForwardRef as ReactComponent };